import * as CONSTANTS from './actions-constants';

export const initialState = {
  /**
   * Reasons a user dislikes a product:
   * ex: productDislikeReasons = {
   *    productId1: ["Not my style", "Wrong size"],
   *    productId2: ["Too cheap"]
   * }
  */
  productDislikeReasons: {},

  /**
   * A product like status [-1 or 1] is associated with a productId:
   * ex: productLikeStatuses = {
   *    productId1: 1,
   *    productId2: -1
   * }
  */
  productLikeStatuses: {}
};

export const userFavoritesReducerKey = 'dataServiceUserFavorites';

export const userFavoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.SET_ALL_LIKE_STATUSES: {
      return {
        ...state,
        productLikeStatuses: action.payload
      };
    }

    case CONSTANTS.UPDATE_PRODUCT_LIKE_STATUSES: {
      const productLikeStatuses = {
        ...state.productLikeStatuses,
        ...action.payload
      };
      return { ...state, productLikeStatuses };
    }

    case CONSTANTS.SET_ALL_DISLIKE_REASONS: {
      return {
        ...state,
        productDislikeReasons: action.payload
      };
    }

    case CONSTANTS.UPDATE_PRODUCT_DISLIKE_REASONS: {
      const productDislikeReasons = {
        ...state.productDislikeReasons,
        ...action.payload
      };
      return { ...state, productDislikeReasons };
    }

    case CONSTANTS.CLEAR_DISLIKE_REASONS: {
      const productDislikeReasons = {
        ...state.productDislikeReasons
      };
      productDislikeReasons[action.payload] = [];
      return { ...state, productDislikeReasons };
    }

    default:
      return state;
  }
};
